import { render, staticRenderFns } from "./PrivacyPolicyEn.vue?vue&type=template&id=130d7a41&scoped=true"
import script from "./PrivacyPolicyEn.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d7a41",
  null
  
)

export default component.exports